<template>
  <v-card v-if="isEnabled" class="success-feedback">
    <hr :class="fullHorizontalSeparator ? 'success my-4' : 'success my-4 mx-2'" />

    <v-card-title class="text-center headline mx-auto">
      {{ t('success.feedback.title') }}
    </v-card-title>

    <v-card-text class="mx-4">
      {{ t('success.feedback.text') }}
    </v-card-text>

    <div class="mx-4">{{ t('success.feedback.textSecond') }}</div>

    <v-card-actions class="feedback-button-container">
      <v-btn
        data-cy="success-view-feedback-participate-btn"
        color="success"
        class="mb-4"
        @click="showFeedbackForm"
      >
        {{ t('success.feedback.confirm') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useLabel } from '@/composables/useLabel';

export default defineComponent({
  props: {
    fullHorizontalSeparator: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isEnabled = ref(false);
    const { t } = useLabel();

    const showFeedbackForm = () => {
      window.open(t('feedback.feedbackLink'), '_blank');
    };

    return {
      isEnabled,
      t,
      showFeedbackForm,
    };
  },
});
</script>

<style scoped>
.success-feedback {
  width: 100%;
}

.feedback-button-container {
  display: flex;
  justify-content: flex-end;
  margin: 0 16px 16px;
}
</style>
